import React, { useState } from 'react'

const ContactSection = () => {
  const [formData, setFormData] = useState({ name: '', phone: '', email: '', description: '' })
  const [isSubmitted, setIsSubmitted] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState('')

  const handleInputChange = (e) => {
    const { name, value } = e.target
    setFormData(prev => ({ ...prev, [name]: value }))
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setIsLoading(true)
    setError('')

    try {
      const response = await fetch('https://n8n.srv1012278.hstgr.cloud/webhook/floristeria-lampugnani-send-form', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          full_name: formData.name,
          phone: formData.phone,
          email: formData.email,
          event_description: formData.description
        })
      })

      if (response.ok) {
        window.location.hash = '#thank-you'
        setFormData({ name: '', phone: '', email: '', description: '' })
      } else {
        throw new Error('Errore nell\'invio del form')
      }
    } catch (error) {
      console.error('Error submitting form:', error)
      setError('Si è verificato un errore nell\'invio del form. Riprova più tardi.')
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <section id="contact-section" className="py-24 bg-white">
      <div className="container mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-serif font-bold text-brand-green mb-4">Contattaci Direttamente</h2>
          <p className="text-lg text-brand-text/70 max-w-3xl mx-auto mb-12">
            Hai domande specifiche o preferisci parlare con noi? Utilizza i contatti qui sotto o compila il form per ricevere una risposta rapida.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 max-w-6xl mx-auto">
          {/* Informazioni di contatto */}
          <div className="flex flex-col justify-center">
            <div className="space-y-8">
              <div className="text-center lg:text-left">
                <h3 className="text-2xl font-serif text-brand-green mb-6">Informazioni di Contatto</h3>
                <div className="space-y-4">
                  <a
                    href="mailto:allestimentilampugnani@gmail.com"
                    className="flex items-center justify-center lg:justify-start text-brand-green hover:text-brand-light-green transition-colors text-lg"
                  >
                    <svg className="w-5 h-5 mr-3" fill="currentColor" viewBox="0 0 20 20">
                      <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z"></path>
                      <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z"></path>
                    </svg>
                    allestimentilampugnani@gmail.com
                  </a>
                  <a
                    href="tel:+393793130376"
                    className="flex items-center justify-center lg:justify-start text-brand-green hover:text-brand-light-green transition-colors text-lg"
                  >
                    <svg className="w-5 h-5 mr-3" fill="currentColor" viewBox="0 0 20 20">
                      <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z"></path>
                    </svg>
                    +39 379 313 0376
                  </a>
                  <div className="space-y-2">
                    <div className="flex items-start justify-center lg:justify-start text-brand-text/80 text-lg">
                      <svg className="w-5 h-5 mr-3 mt-1 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd"></path>
                      </svg>
                      <div>
                        <p>Via Briantea 25c, Orsenigo</p>
                        <p>22030 Como (CO)</p>
                      </div>
                    </div>
                    <div className="flex items-start justify-center lg:justify-start text-brand-text/80 text-lg">
                      <svg className="w-5 h-5 mr-3 mt-1 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd"></path>
                      </svg>
                      <div>
                        <p>Via Michele Barozzi 6</p>
                        <p>20122 Milano (MI)</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Form di contatto */}
          <div className="bg-brand-subtle-bg p-8 rounded-lg">
            {isSubmitted ? (
              <div className="text-center py-12 animate-fade-in">
                <h3 className="text-3xl font-serif text-brand-green mb-3">Messaggio Inviato!</h3>
                <p className="text-brand-text/80">Grazie per averci contattato. Ti risponderemo al più presto.</p>
                <button
                  onClick={() => setIsSubmitted(false)}
                  className="mt-6 text-brand-green hover:text-brand-light-green transition-colors underline"
                >
                  Invia un nuovo messaggio
                </button>
              </div>
            ) : (
              <>
                <h3 className="text-2xl font-serif text-brand-green mb-6 text-center">Scrivici un Messaggio</h3>
                <form onSubmit={handleSubmit} className="space-y-4">
                  <input
                    type="text"
                    name="name"
                    placeholder="Nome e Cognome*"
                    required
                    className="p-3 bg-white border border-transparent rounded-md w-full focus:ring-2 focus:ring-brand-green transition"
                    value={formData.name}
                    onChange={handleInputChange}
                    disabled={isLoading}
                  />
                  <input
                    type="tel"
                    name="phone"
                    placeholder="Numero di Telefono*"
                    required
                    className="p-3 bg-white border border-transparent rounded-md w-full focus:ring-2 focus:ring-brand-green transition"
                    value={formData.phone}
                    onChange={handleInputChange}
                    disabled={isLoading}
                  />
                  <input
                    type="email"
                    name="email"
                    placeholder="Email*"
                    required
                    className="p-3 bg-white border border-transparent rounded-md w-full focus:ring-2 focus:ring-brand-green transition"
                    value={formData.email}
                    onChange={handleInputChange}
                    disabled={isLoading}
                  />
                  <textarea
                    name="description"
                    placeholder="Descrivi la tua richiesta*"
                    rows={4}
                    required
                    className="p-3 bg-white border border-transparent rounded-md w-full focus:ring-2 focus:ring-brand-green transition"
                    value={formData.description}
                    onChange={handleInputChange}
                    disabled={isLoading}
                  ></textarea>

                  {error && (
                    <div className="p-3 bg-red-50 border border-red-200 rounded-md">
                      <p className="text-red-600 text-sm">{error}</p>
                    </div>
                  )}

                  <button
                    type="submit"
                    disabled={isLoading}
                    className="w-full bg-brand-green text-white font-bold py-3 px-6 rounded-md hover:bg-brand-light-green transition-all duration-300 shadow-lg disabled:bg-gray-400 disabled:cursor-not-allowed"
                  >
                    {isLoading ? (
                      <div className="flex items-center justify-center">
                        <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                        </svg>
                        Invio in corso...
                      </div>
                    ) : (
                      'Invia Messaggio'
                    )}
                  </button>
                </form>
              </>
            )}
          </div>
        </div>
      </div>
    </section>
  )
}

export default ContactSection